import {Serializable} from '../deserialize.service';

export class PrintPOSPaymentType implements Serializable<PrintPOSPaymentType> {
    public name: string;
    public value: number;

    deserialize(input: any) {
        this.name = input.name;
        this.value = input.value;

        return this;
    }
}
